import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Input as BaseInput } from '@alfa-bank/site-input';
import { getCaption } from '@alfa-bank/site-form-helpers/meta/get-caption';
import { isError } from '@alfa-bank/site-form-helpers/meta/is-error';
import { isSuccess } from '@alfa-bank/site-form-helpers/meta/is-success';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';

import type { TInput, IDeps } from './models';
import { Input as Component } from './input';

export const FormInput = createWidget<IDeps, TInput>({
    Field,
    BaseInput,
    getCaption,
    isSuccess,
    isError,
})(Component);
